import { useQuery } from "@tanstack/react-query";

import { getActorsActorIDDocuments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "./queryKeys";

export function useActorDocumentsQuery(actorID: string | undefined) {
  return useQuery({
    queryKey: ACTORS_QUERY_KEYS.documents(actorID!),
    queryFn: processResponse(() => getActorsActorIDDocuments(actorID!)),
    enabled: !!actorID,
  });
}
